import React from 'react';
import PropTypes from 'prop-types';
import { CivilDate } from 'tc39-proposal-temporal';

import { Input } from '@bingads-webui-react/primitive-validation';
import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';
import { SingleMonthCalendar } from '@bingads-webui-react/single-month-calendar';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './date-picker-style';

class DatePickerReact extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      NavigatedDate: null,
      SelectedDate: null,
      isShowDatePicker: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideCalendar);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideCalendar);
  }

  static getDerivedStateFromProps(props) {
    if (props.selectedDate) {
      const date = new Date(props.selectedDate);
      const SelectedDate = new CivilDate(
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate()
      );
      return {
        SelectedDate,
        NavigatedDate: SelectedDate,
      };
    }
    return null;
  }

  onSelectDate = (date) => {
    if (this.state.isShowDatePicker) {
      this.setState({
        SelectedDate: date,
        isShowDatePicker: false,
      });
      this.props.onDateChange(date);
    }
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  handleClickOutsideCalendar = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        isShowDatePicker: false,
      });
    }
  }

  render() {
    const {
      i18n,
      classes,
      minDate,
      maxDate,
      inputClassName,
      hideTitle,
      id,
    } = this.props;
    return (
      <div className="date-picker-wrapper">
        <div id={id || 'DatePicker'}>
          {hideTitle ? null : <div className="frequency-title"> { i18n.getString(_TL_('Date')) }</div>}
          <div>
            <Input
              className={inputClassName}
              validationProps={{
                i18n,
              }}
              readOnly
              onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    isShowDatePicker: !this.state.isShowDatePicker,
                  });
                }
              }
              id={id ? `${id}DateInput` : 'DateInput'}
              aria-label={i18n.getString(_TL_('Select date'))}
              value={this.state.SelectedDate ? i18n.formatCivilDate(this.state.SelectedDate, { skeleton: 'yMd' }) : null}
            />
            {
              this.state.isShowDatePicker &&
              <div className={classes.calenderWrapper} ref={this.setWrapperRef}>
                <SingleMonthCalendar
                  minDate={minDate}
                  maxDate={maxDate}
                  defaultNavigatedDate={getCivilDateToday()}
                  defaultSelectedDate={getCivilDateToday()}
                  today={getCivilDateToday()}
                  navigatedDate={this.state.NavigatedDate}
                  selectedDate={this.state.SelectedDate}
                  onSelectDate={date => this.onSelectDate(date)}
                  i18n={i18n}
                  isMonthPickerEnabled
                />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

DatePickerReact.propTypes = {
  classes: PropTypes.shape({
    calenderWrapper: PropTypes.string,
  }).isRequired,
  inputClassName: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onDateChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(CivilDate),
  maxDate: PropTypes.instanceOf(CivilDate),
  hideTitle: PropTypes.bool,
  id: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  selectedDate: PropTypes.instanceOf(CivilDate),
};

DatePickerReact.defaultProps = {
  minDate: null,
  maxDate: null,
  selectedDate: null,
  inputClassName: null,
  hideTitle: false,
  id: undefined,
};

const Wrapped = withDefaultStyles(DatePickerReact, getStyles);

export { Wrapped as DatePickerReact };
